export { default } from './ResetPasswordInput.js'



// WEBPACK FOOTER //
// ./src/App/ResetPasswordInput/index.js